import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { toColor } from './color';

var toStringValue = function toStringValue(color) {
  var newColor = toColor(_objectSpread({}, color));
  return newColor.toRgb().a === 1 ? newColor.toHexString() : newColor.toRgbString();
};

export default toStringValue;